import React, { memo } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import Typography from '@lib/components/Typography/Typography';
import LinkComponent, { LinkTypes } from '@lib/components/Link/Link';
import Placeholder from '@lib/assets/icons/img-placeholder.svg?react';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { useTranslation } from 'react-i18next';
import styles from './AssetPreviewCell.module.scss';

interface Props {
  disabled?: boolean;
  icon?: string | null;
  name: string;
  target?: string;
  url: string;
  usesAsNomenclatureCount?: number;
}

function AssetPreviewCell(props: Props) {
  const { t } = useTranslation();
  const {
    disabled,
    icon,
    name,
    target,
    url,
    usesAsNomenclatureCount = 0,
  } = props;
  const iconRender = icon ? <img src={icon} alt="" /> : <Placeholder />;

  return (
    <LinkComponent
      to={url}
      component={NavLink}
      target={target}
      type={LinkTypes.tertiaryBlack}
      underline={false}
      data-test-id="asset-preview__name-link"
    >
      <div
        className={classNames(styles.wrap, { [styles.wrapDisabled]: disabled })}
      >
        <div className={styles.icon}>{iconRender}</div>
        <div className={styles.info}>
          <Typography variant="caption" strong>
            {usesAsNomenclatureCount > 1 && (
              <div className={styles.warningIcon}>
                <Tooltip body={t('asset-as-nomenclature-text')}>
                  <MaterialIcon icon="warning" symbolsOutlined size="md-16" />
                </Tooltip>
              </div>
            )}
            {name}
          </Typography>
        </div>
      </div>
    </LinkComponent>
  );
}

export default memo(AssetPreviewCell);
